// extracted by mini-css-extract-plugin
module.exports = {"button":"K_bl","article":"K_bp","visible":"K_bq","dividerAnimation":"K_p"};